import React from "react";

import { Header } from "../../../components/header/header";
import { Brands } from "../../../components/brands/brands";
import { CloudPlatform } from "../../../components/cloud-platform/cloud-platform";
import { AnnouncementsContainer } from "../../../components/announcements/announcements";
import { CanDoForYou } from "../../../components/can-do-for-you/can-do-for-you";
import { Comments } from "../../../components/comments/comments";
import { Offer } from "../../../components/offer/offer";
import { ContactsAndSocial } from "../../../components/contacts-and-social/contacts-and-social";
import { Links } from "../../../components/links/links";
import { CopyRight } from "../../../components/copyright/copyright";

import { headerProps } from "./props/header/data";
import { brandsProps } from "./props/brands/data";
import { cloudPlatformEventsProps } from "./props/cloud-platform/events-data";
import { canDoForYouProps } from "./props/can-do-for-you/data";
import { cloudPlatformProps } from "./props/cloud-platform/data";
import { commentProps } from "./props/comments/data";
import { offerProps } from "./props/offer/data";
import { contactsAndSocialProps } from "./props/contacts-and-social/data";
import { linkProps } from "./props/links/data";
import { copyRightProps } from "./props/copyright/data";

import { useGlobalStyles } from "../../../styles/global";
import { useAppStyles } from "./style";
import classNames from "classnames";
import JoinQuizForm from "../../../components/join-quiz-form/join-quiz-form";
import NotificationToaster from "../../../components/notification-toaster/notification-toaster";
import {getCurrentLang} from '../../../locales/locales-utils';
import { useAuth } from "../../../auth/authContext";

export const App = () => {
  const globalClasses = useGlobalStyles();
  const classes = useAppStyles();
  const currentLang = getCurrentLang();
  const { isAuthorizedUser } = useAuth();

  return (
    <>
      <JoinQuizForm />
      <div className={classNames(
        "header " + classes.header,
        { [classes.headerRu]: currentLang !== undefined && currentLang === "ru" }
      )}>
        <div className={globalClasses.container}>
          <Header {...headerProps()} />
        </div>
      </div>
      <div className={classes.brands}>
        <div className={globalClasses.container}>
          <Brands {...brandsProps()} />
        </div>
      </div>
      <div className={classes.cloudPlatformEvents}>
        <div className={globalClasses.container}>
          <CloudPlatform {...cloudPlatformEventsProps()} />
        </div>
      </div>
      <div className={classes.announcementsCarousel}>
        <div className={globalClasses.container}>
          <AnnouncementsContainer />
        </div>
      </div>
      <div className={classes.canDoForYou}>
        <div className={globalClasses.container}>
          <CanDoForYou {...canDoForYouProps()} />
        </div>
      </div>
      <div className={classes.bottomSection}>
        <div className={globalClasses.container}>
          <CloudPlatform {...cloudPlatformProps()} />
        </div>
        <div className={classNames(globalClasses.container, classes.comments)}>
          <Comments data={commentProps()} />
        </div>
        <div className={classes.faq}>
          <div className={globalClasses.container}>
            <Offer {...offerProps({ isAuthorizedUser })} />
          </div>
        </div>
      </div>
      <footer>
        <div className={classes.contactsAndSocial}>
          <div className={globalClasses.container}>
            <ContactsAndSocial {...contactsAndSocialProps()} />
          </div>
        </div>
        <div className={classes.links}>
          <div className={globalClasses.container}>
            <Links data={linkProps()} />
          </div>
        </div>
        <div className={classes.copyRight}>
          <div className={globalClasses.container}>
            <CopyRight {...copyRightProps()} />
          </div>
        </div>
      </footer>
      <NotificationToaster />
    </>
  );
};
